import { createContext, ReactNode, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { logoutUser } from 'services/auth';
import { AuthContextType } from 'types';

import { useLocalStorage } from '../hooks/useLocalStorage';

type Props = { children: ReactNode };

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const AuthProvider = ({ children }: Props) => {
  const [user, setUser] = useLocalStorage('user', null);

  const navigate = useNavigate();

  const authenticate = (data: string) => {
    setUser(data);
  };
  const deleteAllCookies = () => {
    const cookies = document.cookie.split('; ');
    cookies.forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  };
  const logout = () => {
    setUser(null);
    logoutUser();

    deleteAllCookies();

    navigate('/', { replace: true });
  };

  const providerValue = {
    user,
    authenticate,
    logout,
  };

  useEffect(() => {
    if (user) {
      setUser(user);
    }
  }, [user, setUser]);

  return (
    <AuthContext.Provider value={providerValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
